'use client';

import ThemeRegistry from '@/components/ThemeRegistry/ThemeRegistry';
import { GoogleTagManager } from '@next/third-parties/google';
import LogoHeader from '@/components/Header/LogoHeader';
import { LINKS } from '@/constants/constants';

const GTM_AUTH = process.env.NEXT_PUBLIC_GTM_AUTH ?? '';
const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? '';
const GTM_ENV_ID = process.env.NEXT_PUBLIC_GTM_ENV_ID ?? '';

const FB_APP_ID = process.env.NEXT_PUBLIC_FB_APP_ID ?? '';
const FB_ADMINS = process.env.NEXT_PUBLIC_FB_ADMINS ?? '';

const USE_PREVIEW =
  GTM_AUTH && GTM_AUTH !== '' && GTM_ENV_ID && GTM_ENV_ID !== '';

export default function GlobalError({
  error
}: {
  error: Error & { digest?: string };
}) {
  return (
    <html lang='en'>
      <head>
        {/* <link
          rel="stylesheet"
          href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css"
        /> */}
        <meta property='fb:app_id' content={FB_APP_ID} />
        <meta property='fb:admins' content={FB_ADMINS} />
        {USE_PREVIEW ? (
          <GoogleTagManager
            gtmId={GTM_ID}
            preview={GTM_ENV_ID}
            auth={GTM_AUTH}
          />
        ) : (
          <GoogleTagManager gtmId={GTM_ID} />
        )}
      </head>
      <body>
        <ThemeRegistry>
          <div className='app app-container'>
            <div className='app-header'>
              <LogoHeader />
            </div>

            <main
              className='tud-v2 app-body'
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <div className='notfound-page__inner'>
                <div className='notfound-page__title'>
                  Something went wrong!
                </div>
                <div className='notfound-page__text-block'>
                  <p>
                    Please try again shortly. If this keeps happening{' '}
                    <a
                      title='The Urban Developer Support'
                      href={LINKS.contactSupport}
                      target='_blank'
                      rel='noopener'
                    >
                      please let us know here
                    </a>
                    .
                  </p>
                </div>
              </div>
            </main>
            {/* <Footer /> */}
          </div>
        </ThemeRegistry>
      </body>
    </html>
  );
}
